import { MouseEvent } from "react";
import { CircularProgress, IconButton } from "@mui/material";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";

interface VoicePlayButtonProps {
  showInProgress: boolean;
  showStopButton: boolean;
  onPlayClick: () => void;
}

export default function VoicePlayButton({
  showInProgress,
  showStopButton,
  onPlayClick,
}: VoicePlayButtonProps): JSX.Element {
  const handlePlayClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    onPlayClick();
  };

  return (
    <IconButton
      onClick={(e) => {
        if (!showInProgress) handlePlayClick(e);
      }}
    >
      {}
      {showInProgress ? (
        <CircularProgress size="24px" sx={{ color: "secondary.dark" }} />
      ) : showStopButton ? (
        <StopCircleOutlinedIcon sx={{ color: "secondary.dark" }} />
      ) : (
        <PlayCircleOutlinedIcon sx={{ color: "secondary.dark" }} />
      )}
    </IconButton>
  );
}
